import React from "react";
import ServicesPage from "./common/ServicesPage";
import { Heading } from "@chakra-ui/react";
const Manpower = () => {
  return (
    <div>
      <ServicesPage

        title={
                <Heading
                  as="h1"
                  textAlign="center"                     // Center text
                  px={{ base: 4, md: 8 }}               // Responsive horizontal padding
                  fontSize={{ base: "xl", md: "2xl" }} // Responsive font size
                  className="services-title"
                >
                 We supply the team. You keep things moving.    </Heading>
              }
   
        image="/baner (4).png"
        description={
          <>
            <p>
              Our <strong>Manpower Supply Services</strong> At Lions Forge Contracting, we specialize in providing fast, reliable warehouse labour to keep your operations efficient and productive. Whether you're managing daily operations or handling peak demand, we supply experienced workers ready to step in and perform.
            </p>

            <p style={{ marginTop: "1rem" }}>
              From lumpers and packaging staff to certified forklift operators, our team is trained, safety-compliant, and fully equipped to support your warehouse needs.
            </p>

            <ul
              style={{
                marginTop: "1rem",
                paddingLeft: "1.2rem",
                // color: "#FF4D00",
              }}
            >
              <li> Lumpers - Skilled in fast, safe loading and unloading</li>
              <li> Packaging Workers - Efficient, detail-oriented staff for packing and assembly</li>
              <li> Forklift Operators - Certified and experienced for all types of material handling</li>
              <li> General Warehouse Labour - Reliable support for day-to-day operations</li>
            </ul>

            <p style={{ marginTop: "1rem" }}>
          We offer flexible staffing options-short-term, long-term, or last-minute-so you're never caught short.
Stay productive. Stay on schedule.
Trust Lions Forge Contracting to keep your warehouse running at full speed.
            </p>
          </>
        }
      />
    </div>
  );
};

export default Manpower;
